import React, {useState, useEffect, useRef} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import Config from "../../core/config";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import {useNavigate} from "react-router-dom";
import {findTablesByQueryString} from "../../utils/requestUtils";
import {showConfirm} from "../../core/dialog";

const apiUrl = Config.apiUrl;

const PdvTableList = () => {
    const [tables, setTables] = useState([]);
    const [queryString, setQueryString] = useState('');
    const inputQueryString = useRef(null);
    const [, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();

    async function makeQuery(query) {
        try {
            setLoading(true);
            const response = await findTablesByQueryString(query);
            setTables(response);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (inputQueryString.current) inputQueryString.current.focus();
        makeQuery('');
    }, []);

    async function excluirMesa(id) {
        try {
            await makeRequest(apiUrl + '/api/tables/' + id, 'DELETE');
            await makeQuery(queryString);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handleInputChange = (e) => {
        const string = e.target.value;
        if (string.length >= 3 || string.length === 0) makeQuery(string);
        setQueryString(string);
    };

    return (
        <>
            <div className="header-label">Consulta de Mesas</div>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                <input ref={inputQueryString} type="text" value={queryString} onChange={handleInputChange}/>
                <button onClick={() => navigate('/pdv/table-manager')}>Novo</button>
            </div>
            <table style={{width: '580px'}}>
                <thead>
                <tr>
                    <th>Código</th>
                    <th>Nome</th>
                    <th>Habilitado</th>
                    <th/>
                    <th/>
                </tr>
                </thead>
                <tbody>
                {tables.map((table, index) => (
                    <tr key={index}>
                        <td><div>{table.code}</div></td>
                        <td><div>{table.name}</div></td>
                        <td><div>{table.enabled ? 'Sim' : 'Não'}</div></td>
                        <td>
                            <button onClick={() => navigate('/pdv/table-manager?id=' + table.id)}>Editar</button>
                        </td>
                        <td>
                            <button className="remove-button" onClick={async () => {
                                if (await showConfirm('Deseja realmente excluir?')) {
                                    await excluirMesa(table.id);
                                }
                            }}>Excluir</button>
                        </td>
                    </tr>
                ))}
                </tbody>
                {tables.length === 0 && <tfoot><tr><td colSpan={5}>Nenhum item encontrado.</td></tr></tfoot>}
            </table>
        </>
    );
};

export default PdvTableList;
